import { Outlet } from "react-router";

import { AppNav } from "@/app/app-nav";
import { NewClassificationButton } from "./new-classification-button";

export const ClassificationsLayout = () => {
  return (
    <>
      <AppNav>
        <NewClassificationButton />
      </AppNav>
      <main className="flex flex-auto overflow-y-auto">
        <Outlet />
      </main>
    </>
  );
};
